import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import styled from "styled-components";
export var LoggedOutCategoryPageWrapper = styled.div.withConfig({
    componentId: "sc-8986e8e3-0"
})([
    "display:flex;flex-direction:column;width:100%;",
    "{max-width:1920px;margin:auto;padding:",
    ";}",
    "{padding:",
    ";}",
    "{padding:",
    ";}"
], responsiveMediaQueries.desktopAndAbove, getSpacing(0, "6x"), responsiveMediaQueries.tabletAndBelow, getSpacing(0, "2x"), responsiveMediaQueries.mobile, function(param) {
    var $noPaddingOnMobile = param.$noPaddingOnMobile;
    return $noPaddingOnMobile ? "0" : getSpacing(0, "2x");
});
